import { CircularProgress, IconButton, Paper, Typography } from "@mui/material"
import React from "react"
import AddTask from "./AddTask"
import AddIcon from "@mui/icons-material/Add"
import { gql, useQuery } from "@apollo/client"
import { useUser } from "@clerk/clerk-react"
import TaskList from "./TaskList"

const GET_USERS = gql`
  query AllUsers {
    users {
      organisation_id
      id
      name
      email
    }
  }
`

export default function Tasks() {
  const [addTask, setAddTask] = React.useState(false)
  const { user } = useUser()
  const { data, loading, error } = useQuery(GET_USERS)
  if (loading) return <CircularProgress />
  if (error) return <Typography>{error.message}</Typography>
  const users = data.users
  const current_user_id = users.find((u) => u.email === user?.primaryEmailAddress?.emailAddress)?.id
  return (
    <Paper style={{ padding: 10, backgroundColor: "#fafafa" }}>
      <AddTask
        open={addTask}
        setOpen={setAddTask}
        users={users}
        current_user_id={current_user_id}
      />

      <TaskList />
      <IconButton onClick={() => setAddTask(true)}>
        <AddIcon />
      </IconButton>
    </Paper>
  )
}
